module.exports = __webpack_public_path__ + "img/AvenirLTStd-Light.9c3e1500.svg";